<script>
    import { createEventDispatcher, onDestroy } from "svelte";
    import { TopicAccessLevel } from "$/stores/extension/ActiveTopicStore";

    export let role;
    export let editable;

    const dispatch = createEventDispatcher();

    let showDeleteDialog = false;

    let selectedRole = role?.role ?? TopicAccessLevel.VIEWER; // Set the initial value of selectedRole to the role value
    let prevRole = role?.role ?? TopicAccessLevel.VIEWER; // Save the initial role value as the previous role

    function handleRoleChanged(event) {
        selectedRole = parseInt(event.target.value); // Update the selectedRole variable
        prevRole = role.role; // Save the current role as the previous role before updating it
        role.role = selectedRole; // Update the role value

        if (selectedRole !== TopicAccessLevel.MENTION) {
            dispatch("edit", { role: parseInt(selectedRole) }); // dispatch the edit event
        } else {
            showDeleteDialog = true; // show the dialog
        }
    }

    function handleRoleDeleted() {
        showDeleteDialog = false; // hide the dialog
        dispatch("delete"); // dispatch the delete event
    }

    function closeDeleteDialog() {
        showDeleteDialog = false; // hide the dialog
        role.role = prevRole; // restore the previous role value
        selectedRole = prevRole; // restore the previous role value
    }

    onDestroy(() => {
        closeDeleteDialog()
    });
</script>

<div class="user-card">
    {#if showDeleteDialog}
        <div class="dialog">
            <span class="dialog-title"> Remove this user? </span>

            <div class="dialog-btns">
                <button class="dialog-btn" on:click={closeDeleteDialog}>
                    Cancel
                </button>
                <button
                    class="dialog-btn dialog-btn--red"
                    on:click={handleRoleDeleted}
                >
                    Remove
                </button>
            </div>
        </div>
    {/if}

    <div class="user-info">
        {#if role?.user?.firstName || role?.user?.lastName}
            <div class="user-name">
                {role?.user?.firstName ?? ""}
                {role?.user?.lastName ?? ""}
            </div>
        {/if}
        <div class="user-email">
            {role?.user?.username}
        </div>
    </div>

    {#if editable}
        <select
            class="public-role-settings__public-select"
            bind:value={selectedRole}
            on:change={handleRoleChanged}
        >
            <option value={TopicAccessLevel.VIEWER}>Viewer</option>
            <option value={TopicAccessLevel.COMMENTER}>Commenter</option>
            <option value={TopicAccessLevel.EDITOR}>Editor</option>
            <option value={4}>Remove Access</option>
        </select>
    {:else}
        <div class="user-role">
            {#if role?.role === TopicAccessLevel.OWNER}
                Owner
            {:else if role?.role === TopicAccessLevel.EDITOR}
                Editor
            {:else if role?.role === TopicAccessLevel.COMMENTER}
                Commenter
            {:else if role?.role === TopicAccessLevel.VIEWER}
                Viewer
            {:else}
                Visitor
            {/if}
        </div>
    {/if}
</div>

<style>
    @import "../main.css";

    .user-card {
        @apply relative flex flex-row items-center overflow-clip rounded-2xl border border-gray-200 bg-white px-4 py-2 !important;
    }

    .user-info {
        @apply flex flex-col text-sm !important;
    }

    .user-email {
        @apply text-xs !important;
    }

    .user-role {
        @apply ml-auto text-xs italic text-gray-400 !important;
    }

    .public-role-settings__public-select {
        @apply reset ml-auto appearance-auto bg-white text-right text-xs outline-none !important;
    }

    .dialog {
        @apply reset absolute bottom-0 left-0 z-20 flex h-full w-full flex-row items-center bg-pink-100 !important;
    }

    .dialog-title {
        @apply reset px-4 text-sm !important;
    }

    .dialog-btns {
        @apply ml-auto flex select-none items-center justify-end p-2 !important;
    }

    .dialog-btn {
        @apply reset rounded-sm border-none px-2 py-1 text-xs font-normal text-black no-underline hover:bg-pink-200 focus:outline-none !important;
    }

    .dialog-btn--red {
        @apply font-bold text-pink-500 hover:bg-pink-200 !important;
    }
</style>
